import { CardText, Col, Row } from "react-bootstrap";
import {
  Button,
  Card,
  SlideOutModal,
  SlideOutModalProps,
} from "../../../components";
import { sharedProperty, useAsync } from "../../../hooks";
import { SubscriptionItemService } from "../../../services";
import { InvoiceModel } from "../../../data/entities/invoices/InvoiceModel";
import { formatPrice } from "../../../utils";
import { CardBody } from "@progress/kendo-react-all";

export interface ViewSubscriptionInvoiceModalProps extends SlideOutModalProps {
  showInvoiceState: sharedProperty<boolean>;
  message?: string;
  subscriptionItemId?:number;
}

export function ViewSubscriptionInvoiceModal(props: Readonly<ViewSubscriptionInvoiceModalProps>) {
  const subscriptionItemId = props.subscriptionItemId!;
  const subscriptionItemService =new SubscriptionItemService();
  const {value: subscriptionItem} = useAsync(() => subscriptionItemService.get(subscriptionItemId), [subscriptionItemId]);

  const handleInvoiceClick = (invoiceId: number) => {
    // Update link to navigate to invoice details page
    window.location.href = `/invoices/${invoiceId}`;
    props.showState.setter(false);
  };

  return (
    <SlideOutModal
      {...props}
      title="Invoices"
      footer={
        <div className="container p-0">
          <div className="row g-0">
            <div className="pe-2">
              <Button onClick={() => props.showState.setter(false)} variant="cancel" className="w-100">
                Close
              </Button>
            </div>
          </div>
        </div>
      }
    >
    {subscriptionItem && subscriptionItem.invoices && subscriptionItem.invoices.length > 0 ? (
        <>
          {subscriptionItem.invoices
          .sort((a: InvoiceModel, b: InvoiceModel) => a.id - b.id)
          .slice(0,5)
          .map((invoice: InvoiceModel) => (
            <Row key={invoice.id}>
             <Col className="mb-3">
              <Card
               className="clickable-card p-0"
               onClick={() => handleInvoiceClick(invoice.id)}
              >
                <CardBody className="p-0">
                    <CardText className="fw-bold">Invoice #{invoice.id}</CardText>
                    <CardText> Total Amount: {formatPrice(invoice.total)} </CardText>
                    <CardText> Status: 
                     <span className={`${invoice.invoiceStatus === "Posted" ? "text-danger" : invoice.invoiceStatus === "Paid" ? "text-success" : ""}`}>
                        {invoice.invoiceStatus}
                     </span>
                    </CardText>
                </CardBody>
              </Card>
             </Col>
           </Row>
          ))}
        </>
      ) : (
        <CardText>No Invoice available</CardText>        
      )}
    </SlideOutModal>
  );
}

export default ViewSubscriptionInvoiceModal;
